import { createRequestTypes } from '../utils';

export const TASK_ACTION_LIST = createRequestTypes('taskAction/TASK_ACTION_LIST');
export const SAVE_TASK_ACTION = createRequestTypes('taskAction/SAVE_TASK_ACTION');
export const SHOW_TASK_ACTIONS_HISTORY = 'taskAction/SHOW_TASK_ACTIONS_HISTORY';
